import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { showMessage } from "../../messages/messagesActions";
import { ITestTwo } from "./testTwo.types";

function generateAdvanceFilterQuery(data: any) {
  const filters = [];

  for (const [key, value] of Object.entries(data)) {
	if (value !== "" && value !== null) {
	  let filterObj = {
		column: [key],
		operator: "EQUAL",
		value: value,
		logicalOperator: "AND"
	  };
	  if(key === "transaction_date"){
		filterObj = {
		  column: [key],
		  operator: "CONTAINS",
		  value: value+"-",
		  logicalOperator: "AND"
		};
	  }
	  if(key === "user_fact_id"){
		const filterObj = {
		  column: ["producer_one_id", "producer_two_id", "producer_three_id"],
		  operator: "EQUAL",
		  value: value,
		  logicalOperator: "AND"
		};
	
		const encodedFilter = encodeURIComponent(JSON.stringify(filterObj, null, 2));
		filters.push(`advanceFilter=${encodedFilter}`);
	  }else {
		const encodedFilter = encodeURIComponent(JSON.stringify(filterObj, null, 2));
		filters.push(`advanceFilter=${encodedFilter}`);
	  }
  

	 
	}
  }

  return filters.join("&");
}

export const FETCH_TEST_TWO_LIST_PROGRESS = "FETCH_TEST_TWO_LIST_PROGRESS";
export const FETCH_TEST_TWO_LIST_SUCCESS = "FETCH_TEST_TWO_LIST_SUCCESS";
export const FETCH_TEST_TWO_LIST_FAILURE = "FETCH_TEST_TWO_LIST_FAILURE";

export const fetchTestTwoListProgress = () =>
  action(FETCH_TEST_TWO_LIST_PROGRESS);
export const fetchTestTwoListSuccess = (list: ITestTwo[]) =>
  action(FETCH_TEST_TWO_LIST_SUCCESS, { list });
export const fetchTestTwoListFailure = () =>
  action(FETCH_TEST_TWO_LIST_FAILURE);

export const fetchTestTwoListAsync =
  (searchState: {[key: string]: any}): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
	try {
	  dispatch(fetchTestTwoListProgress());
	  const query = generateAdvanceFilterQuery(searchState);
	  let finalUrl = `/customer/get-customer-statement`;
	  if(query){
		finalUrl+= "?"+query
	  }

	  const res = await api.get(finalUrl);
	  const data = res.data.data;
	 dispatch(fetchTestTwoListSuccess(data));
	} catch (err: any) {
	  dispatch(fetchTestTwoListFailure());
	  dispatch(
		showMessage({
		  type: "error",
		  message: err.response.data.message,
		  displayAs: "snackbar",
		})
	  );
	}
  };

export const CLEAR_TEST_TWO_STATE = "CLEAR_TEST_TWO_STATE";
export const clearTestTwoState = () => action(CLEAR_TEST_TWO_STATE);
